export default {
  setJobAdvertisement(state, data) {
    state.jobAdvertisement = data;
  },
  setJobAdvertisementById(state, data) {
    state.jobAdvertisementById = data;
  },

  setDegree(state, data) {
    state.degree = data;
  },

  setCollaborationType(state, data) {
    state.collaborationType = data;
  },

  setCompanyField(state, data) {
    state.companyField = data;
  },

  setJobRequest(state, data) {
    state.jobRequest = data;
  },
  setJobRequestById(state, data) {
    state.jobRequestById = data;
  },

  setSocialNetwork(state, data) {
    state.socialNetwork = data;
  },


};
